import React from 'react';

const CheckOutDetails = () => {
    return (
        <div>
            <h3>This is checkout details</h3>
        </div>
    );
};

export default CheckOutDetails;